import { render, staticRenderFns } from "./TransferComments.vue?vue&type=template&id=247fefad&"
import script from "./TransferComments.vue?vue&type=script&lang=js&"
export * from "./TransferComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports